import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { useContext, useReducer } from 'react';
import { AppMainViewContext } from '../../../ContextProviders/AppContextProvider';
import { ReportViewer } from '../../NetworkCoverage/Display/ReportView';
import { NetworkCoverageMap } from '../../NetworkCoverage/Map/NetworkCoverageMapV3';
import { useCoverage } from '../../NetworkCoverage/ResultRetrieval/hooks/useCoverage';
import { CoverageReportSelector } from '../../NetworkCoverage/Selection/CoverageReports/CoverageReportSelector';
import { NetworkCoverageContext, NetworkCoverageReducer, defaultNetworkCoverageState } from '../../NetworkCoverage/NetworkCoverageContext';
// TODO: remove
import { CoverageReportProvider } from '../../NetworkCoverage/Contexts';
const debug = process.env.REACT_APP_DEBUG && false;
export const PropertyCoverageView = ({ property }) => {
    // main app state
    const [{ isSmallView }] = useContext(AppMainViewContext);
    const [state, dispatch] = useReducer(NetworkCoverageReducer, defaultNetworkCoverageState);
    const { Areas, Places, requestStatusMap } = state;
    const { retrievingReports, coverageReportMap, selectedReports: selectedCoverageReportSks, selectedReportsHash: selectedCoverageReportSksHash, setSelectedReports: setSelectedCoverageReportSks, } = useCoverage({
        coverageGeoObjects: [...Areas, ...Places],
        requestStatusMap,
    });
    debug && console.log('PropertyCoverageView has', { state });
    return (_jsx(NetworkCoverageContext.Provider, { value: { state, dispatch }, children: _jsx(CoverageReportProvider, { retrievingReports,
            coverageReportMap,
            selectedReports: selectedCoverageReportSks,
            selectedReportsHash: selectedCoverageReportSksHash,
            setSelectedReports: setSelectedCoverageReportSks, children: _jsxs(Stack, { minHeight: '60dvh', gap: 1, children: [_jsxs(Stack, { direction: isSmallView ? 'column' : 'row', gap: 1, children: [_jsx(CoverageReportSelector, {}), _jsx(NetworkCoverageMap, { singleContextObject: property })] }), _jsx(ReportViewer, {})] }) }) }));
};
